<div *ngIf="requestIsInFlight" class="text-center">
    <i id="civil-search-spinner" class="fa fa-spinner fa-pulse fa-5x text-center"></i>
</div>
<alert id="case-search-results-alert" type="danger" *ngFor="let error of errors">{{error}}</alert>
<div class="table-responsive" id="case-search-result-table-wrapper-div" *ngIf="cases">          
  <table id="case-search-results-table"
         class="table table-hover table-condensed table-nowrap">
    <thead id="case-search-results-table-header">
      <tr>
        <th width="10%">
            <span class="field-code">V017.a </span>County
            <span><br><span class="field-code">v003.a </span>Case Number</span> 
           <span [popover]="popTemplateForCounty" popoverTitle="County and Case Number" (mouseover)="popOverHandler('onShow')" (mouseleave)="popOverHandler('onHide')"><i class="fa fa-info-circle"></i></span>
        </th>
        <th width="10%">
            <span class="field-code">V486 </span>Case Type
          <span popover="This is a description of the case type.  Case types can be: Civil District, Civil Superior, Small Claims, Criminal District, Criminal Superior, Estates, Special Proceedings, or Registrations." popoverTitle="Case Type" (mouseover)="popOverHandler('onShow')" (mouseleave)="popOverHandler('onHide')"><i class="fa fa-info-circle"></i></span>
        </th>
        <th width="34%">
            <span class="field-code">v085.a </span>Caption
          <span popover="The Case Caption shows the names of the BY and AGAINST parties on the case. Only the first BY and first AGAINST parties named in the case are reported on this line." popoverTitle="Caption" (mouseover)="popOverHandler('onShow')" (mouseleave)="popOverHandler('onHide')"><i class="fa fa-info-circle"></i></span>
        </th>
        <th width="12%">
            Case Issues
          <span popover="An issue can exist without a party." popoverTitle="Case Issues" (mouseover)="popOverHandler('onShow')" (mouseleave)="popOverHandler('onHide')"><i class="fa fa-info-circle"></i></span>
        </th>
        <th width="11%">
            <span class="field-code">V468 </span>Case Status
          <span [popover]="popTemplateForStatus" popoverTitle="Case Status" (mouseover)="popOverHandler('onShow')" (mouseleave)="popOverHandler('onHide')"><i class="fa fa-info-circle"></i></span>
        </th>
        <th width="12%">
            <span class="field-code">V473 </span>Judgment Indexed
          <span popover="A YES in this field indicates there are judgments associated with the case." popoverTitle="Judgment Indexed" (mouseover)="popOverHandler('onShow')" (mouseleave)="popOverHandler('onHide')"><i class="fa fa-info-circle"></i></span>
        </th>
        <th width="11%">
            Actions
           <span [popover]="popTemplateForAction" popoverTitle="Actions" (mouseover)="popOverHandler('onShow')" (mouseleave)="popOverHandler('onHide')"><i class="fa fa-info-circle"></i></span>
        </th>
      </tr>
    </thead>
    <tbody id="case-search-results-table-tbody">
      <ng-container *ngFor="let case of cases; let i = index;">
      <tr id="{{'case-search-results-row-'+ i + '-table-tr-for-case-info'}}"
          (click)="onViewCaseSelected(case.getCaseIdentifier())"
          (mouseover)="onMouseOverCase(i);" 
          (mouseleave)="onMouseOffCase(i);" 
          [class.highlighted-bgcolor]="(mouseOverCaseFlags[i] || isCaseLastViewed(case.getCaseIdentifier()))"> 
        <td id="{{'case-search-results-row-'+ i + '-case-county-and-case-number'}}"
            width="10%"
            title="Click for Case View" ><span title="{{case.getCaseCounty() + ' ' + case.getCaseNumber()}}">{{case.getCaseCounty()}}<br>{{case.getCaseNumber()}}</span></td>
        <td id="{{'case-search-results-row-'+ i + 'case-type'}}"
            width="10%"
            title="Click for Case View" ><span title="{{case.getCaseTypeDescription()}}">{{case.getCaseTypeDescription()}}</span></td>
        <td id="{{'case-search-results-row-'+ i + '-case-caption'}}"
            width="34%"
            title="Click for Case View" ><span title="{{case.getCaseCaption()}}">{{case.getCaseCaption()}}</span></td>
        <td id="{{'case-search-results-row-'+ i + '-case-pleadings-issues'}}"  
            width="12%"
            (click)="$event.stopPropagation()">
           <a id="{{'case-search-results-row-'+ i + '-case-pleadings-issues-show-lnk'}}"
              tabindex="{{1000 +i*5 +1}}"
              title="Click for showing pleadings and issues" (click)="showPleading(i);" *ngIf="!pleadingShowFlags[i]" >
              <span  class="glyphicon glyphicon-plus glyphicon-percent-80"></span><span>Show </span>
           </a>
           <a id="{{'case-search-results-row-'+ i + '-case-pleadings-issues-hide-lnk'}}"
              tabindex="{{1000 + i*5 + 2}}"
              title="Click for hiding pleadings and issues" (click)="hidePleading(i);" *ngIf="pleadingShowFlags[i]">
              <span class="glyphicon glyphicon-minus"></span><span>Hide</span>
           </a>
        </td>  
        <td id="{{'case-search-results-row-'+ i + '-case-status'}}"
            width="11%"
            title="Click for Case View"><span title="{{case.getCaseStatusDescription()}}">{{case.getCaseStatusDescription()}}</span></td>
        <td id="{{'case-search-results-row-'+ i + '-case-judgment'}}"
            width="12%"
            title="Click for Case View"><span title="{{case.getJudgmentDocketedAndIndexed()}}">{{case.getJudgmentDocketedAndIndexed()}}</span></td>
        <td id="{{'case-search-results-row-'+ i + '-case-action'}}" 
            width="11%"
            (click)="$event.stopPropagation()">
          <a id="{{'case-search-results-row-'+ i + '-case-action-view-case-lnk'}}" 
              tabindex="{{1000 + i*5 + 3}}"
              title="Click for Case View" (click)="onViewCaseSelected(case.getCaseIdentifier())">
              <span class="glyphicon glyphicon-folder-open"></span><span> View Case</span>
          </a>
          <br>
          <a  id="{{'case-search-results-row-'+ i + '-case-action-add-case-to-cart-lnk'}}"  
              tabindex="{{1000 + i*5 + 4}}"
              title="Click for Adding Case to Cart" (click)="addCaseToCart(case)"
              *ngIf="!isCaseInCart(case.getCaseIdentifier())">
              <span class="glyphicon glyphicon-shopping-cart"></span><span> Add to Cart</span>
          </a>
          <a id="{{'case-search-results-row-'+ i + '-case-action-remove-case-from-cart-lnk'}}" 
             tabindex="{{1000 + i*5 + 5}}"
             title="Click for Removing Case from Cart" (click)="removeCaseFromCart(case)"
             *ngIf="isCaseInCart(case.getCaseIdentifier())"  >
             <span class="glyphicon glyphicon-shopping-cart"></span><span > Remove</span>
          </a>
        </td>
      </tr>
       <tr id="{{'case-search-results-row-'+ i + '-table-tr-for-case-pleadings-issues'}}" 
           title="Click for Case View" 
           (click)="onViewCaseSelected(case.getCaseIdentifier())"
           (mouseover)="onMouseOverCase(i);" 
           (mouseleave)="onMouseOffCase(i);" 
           [class.highlighted-bgcolor]="(mouseOverCaseFlags[i] || isCaseLastViewed(case.getCaseIdentifier()))"
           *ngIf="pleadingShowFlags[i]">
         <td width="20%" colspan="2" id="{{'case-search-results-row-'+ i + '-table-td-for-pleadings-blanks'}}"></td> 
         <td width="80%" colspan="5" id="{{'case-search-results-row-'+ i + '-table-td-for-pleadings-wrapper'}}"><app-civil-search-results-pleads-grid 
                          [case]="case" 
                          [caseRowIndex]="i" 
                          [rowBeingShown]="pleadingShowFlags[i]"
                          [rowToBeHidden]="pleadingHideNotifyFlags[i]"
                          [bgHighlighted]="(mouseOverCaseFlags[i] || isCaseLastViewed(case.getCaseIdentifier()))" 
                          [maxDisplayRows]="6"
                          (onPleadingClosed)="onPleadingClosed($event);"></app-civil-search-results-pleads-grid></td>
      </tr>
      </ng-container>
     </tbody>
  </table>
</div>
<ng-template #popTemplateForCounty>
    <div class='popover-section'>The Case County is the county where the case was issued.</div>
    <div class='popover-section'>The Case File Number consists of ‘YY&lt;casetype&gt;######’</div>
    <div class='popover-section'>where: </div>
    <div class='popover-section'>YY – two-digit year when case began (i.e. if a case began in 2005 then YY = 05)</div>
    <div class='popover-section'>&lt;casetype&gt; - two or three character code for the type of case (i.e., ‘CVD’ for Civil District, ‘E’ for Estates, ‘CR’ for Criminal, etc.)</div>
    <div class='popover-section'>‘######’ - sequence number for case filed.</div>
</ng-template>
<ng-template #popTemplateForStatus>
    <div>Indicates the status of the case.</div>
    <div class='popover-section'><b>NO PENDING ISSUES</b>- All issues on the case have an order result other than PENDING ORDER and there is no appeal on the case.</div>
    <div class='popover-section'><b>PENDING ISSUE(S)</b> - Any issue on the case has either no order result or an order result of PENDING ORDER and there is no appeal on the case.</div>
    <div class='popover-section'><b>APPEALED</b> - All issues on the case have an order result other than PENDING ORDER but there is an appeal on the case.</div>
    <div class='popover-section'><b>PENDING ISSUE(S)/APPEALED</b> - Any issue on the case has either no order result or an order result of PENDING ORDER and there is an appeal on the case.</div>
</ng-template>
<ng-template #popTemplateForAction>
    <div class='popover-section'>Click &lt;View Case&gt; to see the details on the case.</div>
    <div class='popover-section'>Click &lt;Add To Cart&gt; to add the case to the cart for printing or emailing.</div>
</ng-template>



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-search-results-table/civil-search-results-table.component.html